import React, { useLayoutEffect, useRef } from 'react';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import gsap from 'gsap';

import { Wrapper, StyledDiagram, Illo, ModeDetailsIllustration } from './HomeDiagram.styles';
import {
  Box,
  Container,
  RawData,
  Ingestion,
  Warehouse,
  Mode,
  Transformation,
  Text,
  Flex,
} from '@mode/components';

export const HomeDiagram = () => {
  const containerRef = useRef(null);
  const tl = useRef(null);

  useLayoutEffect(() => {
    let ctx;
    setTimeout(() => {
      ctx = gsap.context(() => {
        gsap.registerPlugin(ScrollTrigger);
        tl.current = gsap.timeline({ defaults: { duration: 1, ease: "sine.out" } })
          .set('.data-icon-top', { autoAlpha: 0 })
          .set('.data-icon-bottom', { autoAlpha: 0 })
          .set('#mode', { autoAlpha: 0 })
          .set('#label-mode', { autoAlpha: 0 })
          .set('#label-transformation', { autoAlpha: 0 })
          .set('#label-warehouse', { autoAlpha: 0 })
          .set('#label-ingestion', { autoAlpha: 0 })
          .set('#label-data', { autoAlpha: 0 })
          .to("#transformation", { y: 0 }, 0)
          .to("#warehouse", { y: 0 }, 0)
          .to("#data", { y: -25 }, 0)
          .to('#label-transformation', { autoAlpha: 1, delay: 0.5 }, '<')
          .to('#label-warehouse', { autoAlpha: 1 }, '<')
          .to('#label-ingestion', { autoAlpha: 1 }, '<')
          .to('#label-data', { autoAlpha: 1 }, '<')
          .to('#mode', { autoAlpha: 1, y: 0 }, '>')
          .to('#label-mode', { autoAlpha: 1 }, '<')
          .to('#mode-details .data-icon-top', { autoAlpha: 1, duration: 0.4 }, ">")
          .to('#mode-details .data-icon-top', { transform: 'translateY(0px)' }, "<")
          .to('#mode-details .data-icon-bottom', { autoAlpha: 1, duration: 0.5 }, "-=0.6")

        ScrollTrigger.create({
          trigger: '#wrapper',
          start: 'top',
          end: '+=1500',
          markers: false,
          pin: '#wrapper',
          scrub: true,
          animation: tl.current,
          anticipatePin: 1,
          onEnter: () => ScrollTrigger.normalizeScroll(true),
          onEnterBack: () => ScrollTrigger.normalizeScroll(true),
          onLeave: () => ScrollTrigger.normalizeScroll(false),
          onLeaveBack: () => ScrollTrigger.normalizeScroll(false),
        })
      }, containerRef.current)
    }, 500)

    return () => {
      if (!ctx) return;
      ctx.revert();
    };
  }, [])

  return (
    <Container ref={containerRef} css={{ width: '100%', overflowX: 'hidden' }} collapseOnMobile>
      <Wrapper id="wrapper">
        <Flex justify="center">
          <StyledDiagram id="diagram">
            <Illo id="mode" css={{ zIndex: 5, transform: 'translateY(-20px)', '@md': { transform: 'translateY(-40px)' } }}>
              <Illo id="mode-details" css={{ position: "absolute", zIndex: 6, transform: 'translateY(30px)', '@md': { transform: 'translateY(80px)' } }}>
                <ModeDetailsIllustration />
              </Illo>
              <Mode />
            </Illo>
            <Illo id="transformation" css={{ zIndex: 4, transform: 'translatey(-60px)', '@md': { transform: 'translateY(-150px)' } }}>
              <Transformation />
            </Illo>
            <Illo id="warehouse" css={{ zIndex: 3, transform: 'translateY(-30px)', '@md': { transform: 'translateY(-75px)' } }}>
              <Warehouse />
            </Illo>
            <Illo id="ingestion" css={{ zIndex: 2 }}>
              <Ingestion />
            </Illo>
            <Illo id="data" css={{ zIndex: 1, margin: '-10px 0', width: '85%', transform: 'translateY(0px)', '@md': { margin: '-20px 0', width: '300px', } }}>
              <RawData />
            </Illo>
          </StyledDiagram>
          <Flex.Item css={{ width: '175px', pl: '$xxs', pt: '0px', '@md': { width: '200px', pt: '130px', pl: '$xs' } }}>
            <Box id="label-mode" css={{ pb: '40px' }}>
              <Box css={{ width: '28px', height: '28px', pb: '$xxxxs', borderRadius: '5px', background: '$g2', mb: '12px' }} />
              <Text css={{ color: '$white' }} textStyle="eyebrow">Modern BI</Text>
            </Box>
            <Box id="label-transformation" css={{ pb: '40px' }}>
              <Box css={{ width: '28px', height: '28px', pb: '$xxxxs', borderRadius: '5px', background: '$p1', mb: '12px' }} />
              <Text css={{ color: '$white' }} textStyle="eyebrow">Transformation</Text>
            </Box>
            <Box id="label-warehouse" css={{ pb: '40px' }}>
              <Box css={{ width: '28px', height: '28px', pb: '$xxxxs', borderRadius: '5px', background: '$b1', mb: '12px' }} />
              <Text css={{ color: '$white' }} textStyle="eyebrow">Warehouse</Text>
            </Box>
            <Box id="label-ingestion" css={{ pb: '40px' }}>
              <Box css={{ width: '28px', height: '28px', pb: '$xxxxs', borderRadius: '5px', background: '$r1', mb: '12px' }} />
              <Text css={{ color: '$white' }} textStyle="eyebrow">Ingestion</Text>
            </Box>
            <Box id="label-data" css={{ pb: '40px' }}>
              <Box css={{ width: '28px', height: '28px', pb: '$xxxxs', borderRadius: '5px', background: '$g1', mb: '12px' }} />
              <Text css={{ color: '$white' }} textStyle="eyebrow">Raw Data</Text>
            </Box>
          </Flex.Item>
        </Flex>
      </Wrapper>
    </Container >
  )
}